import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Image, ImagePropTypes } from "../Image";

import styles from "./GlobalFooter.scss";

const GlobalFooterCertificateImage = forwardRef((props, ref) => {
  const { src, href, alt, title, hiddenMqL, imgProps, ...otherProps } = props;
  return (
    <a
      ref={ref}
      key={src}
      href={href}
      className={`${styles["certificate-image-link"]} ${
        hiddenMqL && styles["certificate-image-link--hidden-mq-l"]
      }`}
      draggable="false"
      {...otherProps}
    >
      <Image
        customClass={styles["certificate-image"]}
        src={src}
        alt={alt}
        title={title}
        draggable="false"
        {...imgProps}
      />
    </a>
  );
});

GlobalFooterCertificateImage.propTypes = {
  src: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hiddenMqL: PropTypes.bool,
  imgProps: PropTypes.shape(ImagePropTypes),
};

GlobalFooterCertificateImage.defaultProps = {
  hiddenMqL: false,
  imgProps: undefined,
};

GlobalFooterCertificateImage.displayName = "GlobalFooter.CertificateImage";

export default GlobalFooterCertificateImage;
